import type { TDict } from "./t";

const pt: Record<TDict, string> = {
  "Browse by category": "Navegar por categoria",
  "Popular articles": "Artigos populares",
  "Whoops! Page not found!": "Ops! Página não encontrada!",
  "Knowledge base of {0}": "Base de conhecimento de {0}",
  "Knowledge base": "Base de conhecimento",
  "Help Center": "Centro de Ajuda",
  "What can we help you find?": "O que podemos ajudar você a encontrar?",
  "Search for articles...": "Pesquisar por artigos...",
  "Search results": "Resultados da pesquisa",
  "Trending articles": "Artigos populares",
  Close: "Fechar",
  "No results": "Sem resultados",
  January: "Janeiro",
  February: "Fevereiro",
  March: "Março",
  April: "Abril",
  May: "Maio",
  June: "Junho",
  July: "Julho",
  August: "Agosto",
  September: "Setembro",
  October: "Outubro",
  November: "Novembro",
  December: "Dezembro",
  "Help Center Search": "Pesquisar no Centro de Ajuda",
  "Search articles in the knowledge base of {0}":
    "Pesquisar artigos na base de conhecimento de {0}",
  "Sort by:": "Ordenar por:",
  '{0} results for "{1}"': '{0} resultados para "{1}"',
  Relevance: "Relevância",
  Date: "Data",
  Title: "Título",
  "Last updated {0}": "Última atualização em {0}",
  "We appreciate your feedback!": "Agradecemos seu feedback!",
  "Was this article helpful?": "Este artigo foi útil?",
  "Vote Up": "Votar para cima",
  "Vote Down": "Votar para baixo",
  "My Tickets": "Meus Tickets",
  "Company tickets": "Tickets da empresa",
  "If you are a customer, login to view your tickets.":
    "Se você é um cliente, faça login para ver seus tickets.",
  Login: "Login",
  "New ticket": "Novo ticket",
  "Add your message...": "Adicionar sua mensagem...",
  "{0} is required": "{0} é obrigatório",
  "Invalid email": "Email inválido",
  "Sorry, an error occurred while creating the ticket":
    "Desculpe, ocorreu um erro ao criar o ticket",
  "Create ticket": "Criar ticket",
  "No tickets here": "Nenhum ticket aqui",
  "Once a new ticket is created, its status will be displayed here.":
    "Uma vez que um novo ticket é criado, seu status será exibido aqui.",
  "No tickets illustration": "Ilustração de tickets",
  Back: "Voltar",
  "Sorry, an error occurred while sending the message":
    "Desculpe, ocorreu um erro ao enviar a mensagem",
  Send: "Enviar",
  "Related articles": "Artigos relacionados",
  "Open tickets": "Tickets abertos",
  "Closed tickets": "Tickets fechados",
  "Show all tickets": "Mostrar todos os tickets",
  "Show open tickets": "Mostrar tickets abertos",
  "Show closed tickets": "Mostrar tickets fechados",
  "Created at": "Criado em",
  "Last message time": "Última mensagem",
  "Failed to update priority": "Falha ao atualizar prioridade",
};

export default pt;
